export default __webpack_public_path__ + "static/media/learning-icon.5d869b7a.svg";